import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'

Alpine.plugin(mask)
window.Alpine = Alpine

import { customSelectLanguage } from './alpine/customSelectLanguage';
import { formHandler } from './alpine/formHandler';
import { initHeader } from './alpine/initHeader';
import { inputTel } from './alpine/inputTel';

import './components/subMenu'
import './components/modals'
import './components/lazyImg'
import './animations/steps'

document.addEventListener('alpine:init', () => {
  Alpine.data('customSelectLanguage', customSelectLanguage);
  Alpine.data('formHandler', formHandler);
  Alpine.data('initHeader', initHeader);
  Alpine.data('inputTel', inputTel);
})

Alpine.start()
